import { LightshowState } from '../lightshow-state';
import { LightShowOperation } from './lightshow-operation';
import { ColorHelpers } from '../../_shared/color-helper';
import { FlashTypes } from '../operation-types';

export class ScreenStrobeOperation extends LightShowOperation {
  public colors: string[];

  constructor(position: number, duration: number, colors: string[]) {
    super();
    this.position = position;
    this.duration = duration;
    this.colors = colors;
    this.flashType = FlashTypes.screenStrobe;
  }

  public toJson() {
    return this.colors.length === 3 ? [{type: FlashTypes.screenStrobe, 
                                        duration: Math.round(this.duration) / 1000, 
                                        time: Math.round(this.position), 
                                        colors: this.colors, 
                                        secondaryProb: 0.33, 
                                        tertiaryProb: 0.33 }] :
                                      [{type: FlashTypes.screenStrobe, 
                                        duration: Math.round(this.duration) / 1000, 
                                        time: Math.round(this.position), 
                                        colors: this.colors, 
                                        secondaryProb: 0.5}];
  }

  end(state: LightshowState): void {}

  tick(state: LightshowState): void {}

  public wait () {}
}